// frontend/src/components/layout/PageContainer.js
import background from "../../assets/images/background.jpg";

export default function PageContainer({ children }) {
  return (
    <div className="page-container">
      <div
        className="page-background"
        style={{
          backgroundImage: `url(${background})`,
        }}
      />

      <div className="page-background-overlay" />

      <div className="page-content">{children}</div>
    </div>
  );
}
